import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: false });

export const apiUrlPrefix =
  process.env.NODE_ENV === "production" ? "/v1" : "/api/v1";

/**
 * Reads the current auth token from the encrypted `cloud.access` store.
 * Returns null when no user is logged in (or the store is empty/corrupt).
 * @returns {string|null}
 */
const getAuthToken = () => {
  try {
    return JSON.parse(ls.get("cloud.access"))?.auth?.user?.token ?? null;
  } catch (e) {
    return null;
  }
};

/**
 * Function to check whether a request error is a network error or axios error
 * @param err {*}
 * @returns {boolean|boolean}
 */
const isNetworkError = err => {
  return !!err.isAxiosError && !err.response;
};

/**
 * Function for rendering the widgets from the components folder
 * @param view
 * @returns {function(): *}
 */
const loadComponent = view => {
  return () => import(`@/components/${view}.vue`);
};

export { loadComponent, isNetworkError, getAuthToken };
